import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo, SlashMark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const AuthSide = () => (
  <div className="hidden lg:flex flex-col justify-between p-12 bg-primary text-primary-foreground relative overflow-hidden grain">
    <div className="absolute -right-24 -bottom-24 h-80 w-80 rounded-full blur-3xl opacity-30 bg-white" aria-hidden />
    <Logo light />
    <div className="relative z-10">
      <SlashMark size={44} color="#fff" className="mb-6" />
      <h2 className="font-display text-4xl font-semibold leading-tight tracking-tight">Every story has a timeline.</h2>
      <p className="mt-4 text-white/75 max-w-sm">Create beautiful interactive timelines and publish them anywhere in minutes.</p>
    </div>
    <div className="text-sm text-white/60">Timeline by Mahakali Studios</div>
  </div>
);

export const AuthShell = ({ children }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-background">
    <AuthSide />
    <div className="flex items-center justify-center p-6 sm:p-12">
      <div className="w-full max-w-sm">
        <div className="lg:hidden mb-8"><Logo /></div>
        {children}
      </div>
    </div>
  </div>
);

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell>
      <h1 className="font-display text-3xl font-semibold tracking-tight text-foreground">Welcome back</h1>
      <p className="mt-2 text-muted-foreground">Log in to continue building.</p>
      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" data-testid="login-email" placeholder="you@example.com" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" data-testid="login-password" placeholder="••••••••" />
        </div>
        <Button type="submit" disabled={busy} className="w-full h-11 rounded-full" data-testid="login-submit">{busy ? "Logging in…" : "Log in"}</Button>
      </form>
      <div className="mt-4 rounded-lg bg-muted p-3 text-xs text-muted-foreground">Demo account: <b>sarv@timeline.app</b> / <b>timeline123</b></div>
      <p className="mt-6 text-sm text-muted-foreground">No account? <Link to="/register" className="text-primary font-medium hover:underline" data-testid="to-register">Sign up</Link></p>
    </AuthShell>
  );
}
